import React from 'react';
import {ZINDEX_FOCUS_COVER} from '../lib/constant';

// eslint-disable-next-line arrow-body-style
const BlockHolder = ({left = 0, top = 0, zIndex = ZINDEX_FOCUS_COVER + 1, rect, path}) => {
    if (rect) {
        left = rect.left;
        top = rect.top;
    }

    return (
        <svg
            style={{position: 'absolute', left:left-268, top, zIndex, pointerEvents: 'none'}}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
        >

            {
                rect != undefined ? (
                    <g
                        transform="translate(0, 0) scale(0.675)"
                        width={rect.width}
                        height={rect.height}
                        style={{pointerEvents: 'auto'}}
                    >
                        <path
                            className="blocklyPath blocklyBlockBackground"
                            stroke="white"
                            style={{strokeWidth: '5px'}}
                            fill="#eeeeee"
                            fillOpacity="0.5"
                            // eslint-disable-next-line max-len
                            //d={`M 0,0 L ${rect.width},0 L ${rect.width},${rect.height} L 0,${rect.height} L 0,0`}
                            d={path.getAttribute('d')}
                        />
                    </g>
                ) :
                (
                    <g
                        transform="translate(0, 0) scale(0.675)"
                        width="300"
                        height="300"
                        style={{pointerEvents: 'auto'}}
                    >
                        <path
                            className="blocklyPath blocklyBlockBackground"
                            stroke="white"
                            style={{strokeWidth: '5px'}}
                            fill="#eeeeee"
                            fillOpacity="0.5"
                            // eslint-disable-next-line max-len
                            d="m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H 115.99999332427979 a 4,4 0 0,1 4,4 v 40  a 4,4 0 0,1 -4,4 H 48   c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z"
                        />
                    </g>
                )
            }
        </svg>
    );
};

export default BlockHolder;
